import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, initialize, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { RichTextField, TextField } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import { mapApiResponseToForm, required } from "./utils"
import { updateEmailSetup } from "store/actions"

const EmailMessagesTab = ({
  emailSetup,
  initializeForm,
  handleSubmit,
  updateEmailSetup,
}) => {
  useEffect(() => {
    if (emailSetup) {
      initializeForm(mapApiResponseToForm(emailSetup))
    }
  }, [emailSetup])

  const saveHandler = data => {
    updateEmailSetup({
      ...emailSetup,
      building_email_addresses: data?.buildingEmailAddresses,
      content: data?.text,
      subject: data?.subject,
    })
  }

  return (
    <React.Fragment>
      <Card className="my-3">
        <CardHeader>
          <h4>Setup</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <p>
                When a new visitor is registered, a confirmation email is sent
                to the user which is registering him and one is sent to the
                actual visitor.
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="mb-0">
                The email sent to the visitor can be configured here.
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                You can use the following variables which will be replaced with
                custom info for each guest. Make sure to use them as follows:
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <ul>
                <li>{`{company_tag}`}</li>
                <li>{`{guest_name}`}</li>
                <li>{`{user_name}`}</li>
                <li>{`{registration_date}`}</li>
                <li>{`{registration_time}`}</li>
              </ul>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12}>
              <label>Email Subject:</label>
            </Col>
            <Col xs={12}>
              <Field
                component={TextField}
                name="subject"
                validate={[required]}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12}>
              <label>Email Text:</label>
            </Col>
            <Col xs={12}>
              <Field
                component={RichTextField}
                name="text"
                validate={[required]}
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <p style={{ margin: "0" }}>
                A copy of the email sent to the visitor will be sent to this
                email address(es), if filled in.
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                If you want to include multiple email addresses you have to
                separate them using a comma. Example: a@gmail.com, b@gmail.com,
                c@gmail.com
              </p>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2">
              <label>Building Email Address(es):</label>
            </Col>
            <Col>
              <Field component={TextField} name="buildingEmailAddresses" />
            </Col>
          </Row>
          <Row className="justify-content-center mt-4">
            <Col xs="auto">
              <SaveButton
                content="Save"
                type="button"
                onClick={handleSubmit(saveHandler)}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  emailSetup: state.Visitors.emailSetup,
})

const mapDispatchToProps = dispatch => ({
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.EMAIL_MESSAGES_SETUP, values)),
  updateEmailSetup: values => dispatch(updateEmailSetup(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.EMAIL_MESSAGES_SETUP })(EmailMessagesTab))
